var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgWishlistActive = function SvgWishlistActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 1980",
    transform: "translate(-210 -2161)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 1654",
    width: 48,
    height: 48,
    rx: 12,
    transform: "translate(210 2161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.514 2176.853a6.017 6.017 0 0 1 8.687 0 6.461 6.461 0 0 1 0 8.947l-8.743 9a.634.634 0 0 1-.915 0l-8.743-9a6.461 6.461 0 0 1 0-8.947 6.017 6.017 0 0 1 8.687 0l.513.529Z",
    fill: "#e81e61"
  }))));
};
export default SvgWishlistActive;